import { makeStyles } from '@mui/styles';

// colors
// import { colors } from '../../../colors';

export const useStyles = makeStyles({
  container: {
    width: '100%',
    '& .MuiSkeleton-rectangular': {
      borderRadius: 10,
    },
  },
  chatHeader: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  userCard: {
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    gap: 16,
  },
  contentLoaderCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  square: {
    borderRadius: '0 !important',
  },
});
